import { MdCheck } from 'react-icons/md'

import styled from 'styled-components'

import { colors } from '../../styles/colors'
import Text from '../Text'
interface IContainer {
  backgroundColor?: string
}
export const Container = styled.div<IContainer>`
  display: flex;
  height: 100%;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ backgroundColor }) => backgroundColor ?? colors.blue};
`
export const ContainerFeedback = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 500px;
  margin-bottom: 20px;
`

export const Logo = styled.img`
  width: 130px;
  height: 37.49px;
`
interface IIcon {
  size?: number
}
export const Icon = styled.img<IIcon>`
  width: ${({ size }) => size ?? 120}px;
  height: ${({ size }) => size ?? 120}px;

  margin: 25px 15px;
`
export const Title = styled.span`
  font-weight: 700;
  font-size: 23px;

  text-align: center;

  color: ${colors.white};

  line-height: 40px;
`
export const SubTitle = styled.span`
  font-weight: 400;
  font-size: 28px;

  color: ${colors.white};
`

export const StyledText = styled(Text)`
  text-align: center;
  padding-top: 15px;
`

export const StyledCheck = styled(MdCheck)<{
  color?: string
  fontSize?: number
}>`
  color: ${p => (p.color ? p.color : colors.blue)};
  font-size: ${p => (p.fontSize ? p.fontSize : '80px !important')};
  padding: 10px 10px 10px 10px;
  border: 3px solid ${p => (p.color ? p.color : colors.blue)};
  border-radius: 50%;
  margin: 25px 15px;
`
